import { FC, useContext, useMemo } from 'react'
import { useQuery } from 'react-query'
import {
  createResponseContext,
  initialQueryResponse,
  QUERIES,
  stringifyRequestQuery,
  WithChildren,
} from '../../../../../../_metronic/helpers'
import { useQueryRequest } from './QueryRequestProvider'
import { useSearchParams } from 'react-router-dom'
import { getCargosCliente } from './_request'
import { CargoAsoList } from './_models'
import { useModal } from '../../../../../components'

const QueryResponseContext = createResponseContext<CargoAsoList>(initialQueryResponse)
export const QueryResponseProvider: FC<WithChildren> = ({ children }) => {
  const { isOpen } = useModal()
  const { state } = useQueryRequest()

  const query = useMemo(() => stringifyRequestQuery(state), [state])

  const [searchParams] = useSearchParams()
  const empresa = Number(searchParams.get('empresa'))

  const {
    isFetching,
    isError,
    refetch,
    data: response,
  } = useQuery(
    [QUERIES.EMPRESA_CLIENTE_CARGOS_LIST, query, isOpen],
    () => getCargosCliente(Number(empresa), query),
    { cacheTime: 0, keepPreviousData: true, refetchOnWindowFocus: false, enabled: !isOpen }
  )

  return (
    <QueryResponseContext.Provider
      value={{ isLoading: isFetching, isError, refetch, response, query }}
    >
      {children}
    </QueryResponseContext.Provider>
  )
}

export const useQueryResponse = () => useContext(QueryResponseContext)
